export const formatSegmentLabel = (index: number): string => {
  const hours = Math.floor(index / 4);
  const minutes = (index % 4) * 15;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};

export const formatTimePeriodRangeLabel = (timeSegment: number): string =>
  `${formatSegmentLabel(timeSegment)} - ${formatSegmentLabel(timeSegment + 1)}`;
